import { Toast } from 'jamespot-front-business';
import { JRCAlert } from 'jamespot-react-components';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { useAppSelector } from '../redux/store';

const ToastContainer = styled.div`
    position: absolute;
    z-index: ${({ theme }) => theme.zIndex.toaster};
    top: calc(var(--header-height, 91px) + 10px);
    right: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    overflow: hidden;
`;

export const Toaster = () => {
    const [isUnload, setIsUnload] = useState(false);
    const toasts = useAppSelector(Toast.selectors.selectAll);
    const intl = useIntl();

    // on ajoute un event listener sur le beforeunload pour eviter d'afficher les toasts lors d'un reload de page
    // sur firefox, les requetes throw une erreur et on a un/des toast qui s'affichent si on ne le fait pas
    useEffect(() => {
        const handleBeforeUnload = () => {
            setIsUnload(true);
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    if (isUnload) return null;

    return (
        <ToastContainer>
            {toasts.map((toast) => {
                const labelValue =
                    typeof toast.label === 'object'
                        ? intl.formatMessage({ id: toast.label.id }, toast.label.values)
                        : intl.formatMessage({ id: toast.label });
                const descriptionValue =
                    typeof toast.description === 'string'
                        ? intl.formatMessage({ id: toast.description })
                        : toast.description
                        ? intl.formatMessage({ id: toast.description.id }, toast.description.values)
                        : undefined;

                return (
                    <JRCAlert
                        key={toast.id}
                        label={labelValue}
                        description={descriptionValue}
                        type={toast.type}
                        timeout={toast.timeout}
                        hasLoader={true}
                    />
                );
            })}
        </ToastContainer>
    );
};
